import HeroCarousel from "./components/HeroCarousel";
import CategoryQuickEntry from "./components/CategoryQuickEntry";
import HotSection from "./components/HotSection";
import LatestShorts from "./components/LatestShorts";
import TopicCollections from "./components/TopicCollections";
import { getByType, getFeatured, videos } from "@/mocks/videos";
import { Link } from "react-router-dom";

export default function Home() {
  const featured = getFeatured();

  const movieHot = [...getByType("movie")].sort((a, b) => b.popularity - a.popularity).slice(0, 8);
  const tvHot = [...getByType("tv")].sort((a, b) => b.popularity - a.popularity).slice(0, 8);
  const latestShorts = [...getByType("short")].sort((a, b) => b.createdAt.localeCompare(a.createdAt)).slice(0, 6);

  const totalCount = videos.length;

  return (
    <>
      <HeroCarousel items={featured} />

      <CategoryQuickEntry />

      <div className="bg-background-100">
        <HotSection title="电影热播榜" subtitle="人气与口碑兼具的电影，本周最受关注" videos={movieHot} morePath="/category/movie" />
      </div>

      <HotSection title="电视剧热播榜" subtitle="正在被追的剧集，热度持续攀升" videos={tvHot} morePath="/category/tv" />

      <LatestShorts videos={latestShorts} />

      <TopicCollections />

      <section className="w-full px-4 md:px-8 pb-4">
        <div className="rounded-lg bg-primary-950 px-6 md:px-12 py-12 md:py-16 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-background-50 mb-4 leading-snug">
              一个平台，看遍电影、电视剧与短视频
            </h2>
            <p className="text-sm md:text-base text-background-100/80 leading-relaxed max-w-xl">
              69视频聚合了多类型高清视频资源，通过多维筛选、关键词搜索与智能推荐，帮助你快速找到想看的内容。
              本站为演示站点，内容均为示例数据，不提供真实播放与下载服务。
            </p>
            <div className="flex items-center gap-4 mt-6 flex-wrap">
              <Link
                to="/about"
                className="px-6 py-3 rounded-md bg-accent-500 text-primary-950 text-sm font-semibold hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                了解我们
              </Link>
              <Link
                to="/category/movie"
                className="px-6 py-3 rounded-md border border-background-100/40 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                开始探索
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4 md:gap-6">
            <div className="text-center">
              <p className="font-heading font-bold text-3xl md:text-4xl text-accent-400">{totalCount}+</p>
              <p className="text-xs md:text-sm text-background-100/75 mt-2">精选内容</p>
            </div>
            <div className="text-center">
              <p className="font-heading font-bold text-3xl md:text-4xl text-accent-400">3</p>
              <p className="text-xs md:text-sm text-background-100/75 mt-2">内容分类</p>
            </div>
            <div className="text-center">
              <p className="font-heading font-bold text-3xl md:text-4xl text-accent-400">24h</p>
              <p className="text-xs md:text-sm text-background-100/75 mt-2">持续更新</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}